import React from 'react';
import NavigationBar from '../Shared/NavigationBar/NavigationBar';
import MyProjects from './MyProjects/MyProjects';

const Projects = () => {
    return (
        <div>
            <NavigationBar/>
            <MyProjects/>
        </div>
    );
};

export default Projects;